import { render, staticRenderFns } from "./ImportantInformation.vue?vue&type=template&id=7759990b&scoped=true"
import script from "./ImportantInformation.vue?vue&type=script&lang=js"
export * from "./ImportantInformation.vue?vue&type=script&lang=js"
import style0 from "./ImportantInformation.vue?vue&type=style&index=0&id=7759990b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7759990b",
  null
  
)

export default component.exports